import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ 追加 ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ 追加 ▼▼▼
import './Garden.css';

const PrimeLocation = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ 追加 ▼▼▼

    return (
        // ▼▼▼ 全体をフラグメント <> で囲みます ▼▼▼
        <>
            {/* ▼▼▼ このHelmetブロックを丸ごと追加します ▼▼▼ */}
            <Helmet>
                <title>金沢観光の拠点に最適な立地｜5つの魅力｜金沢之旅宿 あけぼの</title>
                <meta name="description" content="金沢之旅宿あけぼのは、兼六園や金沢21世紀美術館へ徒歩8分。にし茶屋街や金沢城公園、香林坊にもアクセス抜群。金沢観光の拠点として最適なロケーションです。" />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="金沢観光の拠点に最適な立地｜金沢之旅宿 あけぼの" />
                <meta property="og:description" content="兼六園や金沢21世紀美術館へ徒歩8分。主要な観光スポットにアクセス抜群な、金沢観光の拠点として最適なロケーションです。" />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/access1.jpg" />
            </Helmet>
            {/* ▲▲▲ ここまで追加 ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HEROセクション */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/access1.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>金沢観光の拠点に</h1>
                    </div>
                </section>

                {/* 周辺施設案内 */}
                <section className="akebono-garden-feature">
                    <h2>周辺施設のご案内</h2>

                    <div className="garden-card">
                        <img src="/images/spot-kenrokuen.jpg" alt="兼六園" onClick={() => setLightboxImage('/images/spot-kenrokuen.jpg')} />
                        <div>
                            <h3>兼六園（徒歩8分）</h3>
                            <p>日本三名園として有名。四季を通じて自然の美を堪能できます。特に冬の“雪吊り”は見どころのひとつです。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-21museum.jpg" alt="金沢21世紀美術館" onClick={() => setLightboxImage('/images/spot-21museum.jpg')} />
                        <div>
                            <h3>金沢21世紀美術館（徒歩8分）</h3>
                            <p>全国的に有名な現代アートの拠点。レアンドロ・エルリッヒ作《スイミング・プール》が特に人気です。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-nishichaya.jpg" alt="にし茶屋街" onClick={() => setLightboxImage('/images/spot-nishichaya.jpg')} />
                        <div>
                            <h3>にし茶屋街（徒歩20分）</h3>
                            <p>ひがし・主計町と並ぶ金沢三茶屋街のひとつ。華やかな芸妓文化が息づく情緒ある町並みです。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-kanazawacastle.jpg" alt="金沢城公園" onClick={() => setLightboxImage('/images/spot-kanazawacastle.jpg')} />
                        <div>
                            <h3>金沢城公園（徒歩20分）</h3>
                            <p>兼六園に隣接する広々とした歴史公園。四季折々の散策をお楽しみいただけます。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-korinbo.jpg" alt="香林坊" onClick={() => setLightboxImage('/images/spot-korinbo.jpg')} />
                        <div>
                            <h3>香林坊エリア（徒歩20分）</h3>
                            <p>百貨店やホテル、ファッションビルが並ぶ、金沢随一のショッピング街です。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-katamachi.jpg" alt="片町" onClick={() => setLightboxImage('/images/spot-katamachi.jpg')} />
                        <div>
                            <h3>片町エリア（徒歩15分）</h3>
                            <p>金沢の夜の顔として知られる飲食店街。九谷焼や輪島漆器のショップも点在しています。</p>
                        </div>
                    </div>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="拡大表示" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ 全体をフラグメント <> で囲みます ▲▲▲
    );
};

export default PrimeLocation;